import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import lightTheme from "../theme";
import ScrollIntoView from "react-scroll-into-view";

const Navbar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" color="complementary">
      <Container>
        <Toolbar disableGutters>
          <Container
            sx={{
              width: "auto",
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
            }}
          >
            <img
              src="https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/logo_transparent_background(1).png"
              style={{
                width: "auto",
                height: "80px",
                aspectRatio: "inherit",
                margin: "0px 20px",
              }}
              alt="logo"
            ></img>
          </Container>

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              <ScrollIntoView onClick={handleCloseNavMenu} selector="#services">
                <MenuItem>
                  <Typography textAlign="center">Services</Typography>
                </MenuItem>
              </ScrollIntoView>
              <ScrollIntoView onClick={handleCloseNavMenu} selector="#legalFAQ">
                <MenuItem>
                  <Typography textAlign="center" >
                    Common Legal Issues Q&A
                  </Typography>
                </MenuItem>
              </ScrollIntoView>
              <ScrollIntoView onClick={handleCloseNavMenu} selector="#myTeam">
                <MenuItem>
                  <Typography textAlign="center">My Team</Typography>
                </MenuItem>
              </ScrollIntoView>
              <ScrollIntoView
                onClick={handleCloseNavMenu}
                selector="#testimonials"
              >
                <MenuItem>
                  <Typography textAlign="center">Testimonials</Typography>
                </MenuItem>
              </ScrollIntoView>
              <ScrollIntoView onClick={handleCloseNavMenu} selector="#contact">
                <MenuItem>
                  <Typography textAlign="center">Contact</Typography>
                </MenuItem>
              </ScrollIntoView>
            </Menu>
          </Box>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "center",
            }}
          >
            <img
              src="https://edrusslaw-wziller.s3.us-east-2.amazonaws.com/logo_transparent_background(1).png"
              style={{
                width: "25%",
                objectFit: "cover",
                aspectRatio: "initial",
                margin: "0px 20px",
              }}
              alt="logo"
            ></img>
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "space-evenly",
            }}
          >
            <ScrollIntoView selector="#services">
              <Button
                sx={{
                  my: 2,
                  color: lightTheme.palette.titleColor.main,
                  display: "block",
                  fontSize:"14pt",
                  fontWeight:"bold"
                }}
              >
                Services
              </Button>
            </ScrollIntoView>
            <ScrollIntoView selector="#legalFAQ">
              <Button
                sx={{
                  my: 2,
                  color: lightTheme.palette.titleColor.main,
                  display: "block",
                  fontSize:"14pt",
                  fontWeight:"bold"
                }}
              >
                Common Legal Issues Q&A
              </Button>
            </ScrollIntoView>
            <ScrollIntoView selector="#myTeam">
              <Button
                value="#testimonials"
                sx={{
                  my: 2,
                  color: lightTheme.palette.titleColor.main,
                  display: "block",
                  fontSize:"14pt",
                  fontWeight:"bold"
                }}
              >
                My Team
              </Button>
            </ScrollIntoView>
            <ScrollIntoView selector="#testimonials">
              <Button
                value="#testimonials"
                sx={{
                  my: 2,
                  color: lightTheme.palette.titleColor.main,
                  display: "block",
                  fontSize:"14pt",
                  fontWeight:"bold"
                }}
              >
                Testimonials
              </Button>
            </ScrollIntoView>
            <ScrollIntoView selector="#contact">
              <Button
                value="#testimonials"
                sx={{
                  my: 2,
                  color: lightTheme.palette.titleColor.main,
                  display: "block",
                  fontSize:"14pt",
                  fontWeight:"bold"
                }}
              >
                Contact
              </Button>
            </ScrollIntoView>
          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            ></Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Navbar;
